import React, { useState, useEffect } from "react";
import {
  GiFruitBowl,
  GiBroccoli,
  GiOlive,
  GiGrainBundle,
  GiDrippingHoney,
  GiPeas,
  GiPeanut,
  GiOctopus,
  GiDoubleFish,
  GiMilkCarton,
  GiJug,
  GiWineBottle,
  GiSadCrab,
} from "react-icons/gi";
import { BsEggFried, BsCircleFill } from "react-icons/bs";
import { TbMeat, TbCheese } from "react-icons/tb";
import { Badge, Tag } from "antd";
const TranslatedText = ({ greekText, englishText }) => {
  const [translatedText, setTranslatedText] = useState("");

  useEffect(() => {
    const lang = document.documentElement.lang;
    if (lang === "el") {
      setTranslatedText(greekText);
    } else {
      setTranslatedText(englishText);
    }
  }, [greekText, englishText]);

  return <span dangerouslySetInnerHTML={{ __html: translatedText }} />;
};
const tagChoices = [
  {
    tag: "fasting",
    name: "Αλάδωτο (Ξηροφαγία)",
    nameen: "fasting",
    color: "#F96A3D",
    allow: [
      { icon: GiFruitBowl, namegr: "Φρούτα", nameen: "Fruits" },
      { icon: GiBroccoli, namegr: "Λαχανικά", nameen: "Vegetables" },
      { icon: GiOlive, namegr: "Ελιές", nameen: "Olive" },
      {
        icon: GiGrainBundle,
        namegr: "Προϊόντα που βασίζονται στα δημητριακά",
        nameen: "Cereal Products",
      },
      { icon: GiDrippingHoney, namegr: "Μέλι", nameen: "Honey" },
      { icon: GiPeas, namegr: "Όσπρια", nameen: "Legumes" },
      { icon: GiPeanut, namegr: "Ξηροί Καρποί", nameen: "Νuts" },
      {
        icon: GiSadCrab,
        namegr: "Οστρακοειδή & Μαλάκια",
        nameen: "Crustaceans & Molluscs",
      },
    ],
    notAllow: [
      { icon: GiDoubleFish, namegr: "Ψάρια", nameen: "Fish" },
      { icon: TbCheese, namegr: "Γαλακτομικά", nameen: "Dairy" },
      { icon: BsEggFried, namegr: "Αυγά", nameen: "Eggs" },
      { icon: GiJug, namegr: "Λάδι", nameen: "Olive Oil" },
      {
        icon: GiWineBottle,
        namegr: "Κρασί/ Οινοπνευματώδη ποτά",
        nameen: "Wine/ Alcohol",
      },
      { icon: TbMeat, namegr: "Κρέας", nameen: "Meat" },
    ],
    button: [
      {
        namegr: "Λαχανικά",
        nameen: "Vegetables",
        url: "https://nutrition.epantokrator.gr/%CE%B1%CE%BD%CE%B1-%CE%BA%CE%B1%CF%84%CE%B7%CE%B3%CE%BF%CF%81%CE%AF%CE%B1-%CF%85%CE%BB%CE%B9%CE%BA%CF%8E%CE%BD/#vegetables",
      },
      {
        namegr: "Οστρακοειδή & Μαλάκια",
        nameen: "Crustaceans & Molluscs",
        url: "https://nutrition.epantokrator.gr/%CE%B1%CE%BD%CE%B1-%CE%BA%CE%B1%CF%84%CE%B7%CE%B3%CE%BF%CF%81%CE%AF%CE%B1-%CF%85%CE%BB%CE%B9%CE%BA%CF%8E%CE%BD/#crustaceans",
      },
      {
        namegr: "Όσπρια",
        nameen: "Legumes",
        url: "https://nutrition.epantokrator.gr/%CE%B1%CE%BD%CE%B1-%CE%BA%CE%B1%CF%84%CE%B7%CE%B3%CE%BF%CF%81%CE%AF%CE%B1-%CF%85%CE%BB%CE%B9%CE%BA%CF%8E%CE%BD#legumes",
      },
      {
        namegr: "Ζυμαρικά",
        nameen: "Pasta",
        url: "https://nutrition.epantokrator.gr/%CE%B1%CE%BD%CE%B1-%CE%BA%CE%B1%CF%84%CE%B7%CE%B3%CE%BF%CF%81%CE%AF%CE%B1-%CF%85%CE%BB%CE%B9%CE%BA%CF%8E%CE%BD/#pasta",
      },
      {
        namegr: "Ρύζι",
        nameen: "Rice",
        url: "https://nutrition.epantokrator.gr/%CE%B1%CE%BD%CE%B1-%CE%BA%CE%B1%CF%84%CE%B7%CE%B3%CE%BF%CF%81%CE%AF%CE%B1-%CF%85%CE%BB%CE%B9%CE%BA%CF%8E%CE%BD/#rice",
      },
    ],
  },
  {
    tag: "everything",
    nameen: "Every food is allowed",
    name: "Κατάλυση εις πάντα",
    color: "#2B0668",
    allow: [
      { icon: GiFruitBowl, namegr: "Φρούτα", nameen: "Fruits" },
      { icon: GiBroccoli, namegr: "Λαχανικά", nameen: "Vegetables" },
      { icon: GiOlive, namegr: "Ελιές", nameen: "Olive" },
      {
        icon: GiGrainBundle,
        namegr: "Προϊόντα που βασίζονται στα δημητριακά",
        nameen: "Cereal Products",
      },
      { icon: GiDrippingHoney, namegr: "Μέλι", nameen: "Honey" },
      { icon: GiPeas, namegr: "Όσπρια", nameen: "Legumes" },
      { icon: GiPeanut, namegr: "Ξηροί Καρποί", nameen: "Νuts" },
      {
        icon: GiSadCrab,
        namegr: "Οστρακοειδή & Μαλάκια",
        nameen: "Crustaceans & Molluscs",
      },
      { icon: GiDoubleFish, namegr: "Ψάρια", nameen: "Fish" },
      { icon: TbCheese, namegr: "Γαλακτομικά", nameen: "Dairy" },
      { icon: BsEggFried, namegr: "Αυγά", nameen: "Eggs" },
      { icon: GiJug, namegr: "Λάδι", nameen: "Olive Oil" },
      {
        icon: GiWineBottle,
        namegr: "Κρασί/ Οινοπνευματώδη ποτά",
        nameen: "Wine/ Alcohol",
      },
      { icon: TbMeat, namegr: "Κρέας", nameen: "Meat" },
    ],
    button: [
      {
        namegr: "Λαχανικά",
        nameen: "Vegetables",
        url: "https://nutrition.epantokrator.gr/%CE%B1%CE%BD%CE%B1-%CE%BA%CE%B1%CF%84%CE%B7%CE%B3%CE%BF%CF%81%CE%AF%CE%B1-%CF%85%CE%BB%CE%B9%CE%BA%CF%8E%CE%BD/#vegetables",
      },

      {
        namegr: "Ψάρια",
        nameen: "Fish",
        url: "https://nutrition.epantokrator.gr/%CE%B1%CE%BD%CE%B1-%CE%BA%CE%B1%CF%84%CE%B7%CE%B3%CE%BF%CF%81%CE%AF%CE%B1-%CF%85%CE%BB%CE%B9%CE%BA%CF%8E%CE%BD/#fish",
      },
      {
        namegr: "Οστρακοειδή & Μαλάκια",
        nameen: "Crustaceans & Molluscs",
        url: "https://nutrition.epantokrator.gr/%CE%B1%CE%BD%CE%B1-%CE%BA%CE%B1%CF%84%CE%B7%CE%B3%CE%BF%CF%81%CE%AF%CE%B1-%CF%85%CE%BB%CE%B9%CE%BA%CF%8E%CE%BD/#crustaceans",
      },
      {
        namegr: "Όσπρια",
        nameen: "Legumes",
        url: "https://nutrition.epantokrator.gr/%CE%B1%CE%BD%CE%B1-%CE%BA%CE%B1%CF%84%CE%B7%CE%B3%CE%BF%CF%81%CE%AF%CE%B1-%CF%85%CE%BB%CE%B9%CE%BA%CF%8E%CE%BD#legumes",
      },
      {
        namegr: "Ζυμαρικά",
        nameen: "Pasta",
        url: "https://nutrition.epantokrator.gr/%CE%B1%CE%BD%CE%B1-%CE%BA%CE%B1%CF%84%CE%B7%CE%B3%CE%BF%CF%81%CE%AF%CE%B1-%CF%85%CE%BB%CE%B9%CE%BA%CF%8E%CE%BD/#pasta",
      },
      {
        namegr: "Ρύζι",
        nameen: "Rice",
        url: "https://nutrition.epantokrator.gr/%CE%B1%CE%BD%CE%B1-%CE%BA%CE%B1%CF%84%CE%B7%CE%B3%CE%BF%CF%81%CE%AF%CE%B1-%CF%85%CE%BB%CE%B9%CE%BA%CF%8E%CE%BD/#rice",
      },
      {
        namegr: "Αυγά",
        nameen: "Eggs",
        url: "https://nutrition.epantokrator.gr/%CE%B1%CE%BD%CE%B1-%CE%BA%CE%B1%CF%84%CE%B7%CE%B3%CE%BF%CF%81%CE%AF%CE%B1-%CF%85%CE%BB%CE%B9%CE%BA%CF%8E%CE%BD/#eggs",
      },
    ],
  },
  {
    tag: "wine",
    nameen: "Wine and Olive Oil are allowed",
    name: "Κατάλυση οίνου και ελαίου",
    color: "#EBE318",
    allow: [
      { icon: GiFruitBowl, namegr: "Φρούτα", nameen: "Fruits" },
      { icon: GiBroccoli, namegr: "Λαχανικά", nameen: "Vegetables" },
      { icon: GiOlive, namegr: "Ελιές", nameen: "Olive" },
      {
        icon: GiGrainBundle,
        namegr: "Προϊόντα που βασίζονται στα δημητριακά",
        nameen: "Cereal Products",
      },
      { icon: GiDrippingHoney, namegr: "Μέλι", nameen: "Honey" },
      { icon: GiPeas, namegr: "Όσπρια", nameen: "Legumes" },
      { icon: GiPeanut, namegr: "Ξηροί Καρποί", nameen: "Νuts" },
      {
        icon: GiSadCrab,
        namegr: "Οστρακοειδή & Μαλάκια",
        nameen: "Crustaceans & Molluscs",
      },

      { icon: GiJug, namegr: "Λάδι", nameen: "Olive Oil" },
      {
        icon: GiWineBottle,
        namegr: "Κρασί/ Οινοπνευματώδη ποτά",
        nameen: "Wine/ Alcohol",
      },
    ],
    notAllow: [
      { icon: GiDoubleFish, namegr: "Ψάρια", nameen: "Fish" },
      { icon: TbCheese, namegr: "Γαλακτομικά", nameen: "Dairy" },
      { icon: BsEggFried, namegr: "Αυγά", nameen: "Eggs" },
      { icon: TbMeat, namegr: "Κρέας", nameen: "Meat" },
    ],
    button: [
      {
        namegr: "Λαχανικά",
        nameen: "Vegetables",
        url: "https://nutrition.epantokrator.gr/%CE%B1%CE%BD%CE%B1-%CE%BA%CE%B1%CF%84%CE%B7%CE%B3%CE%BF%CF%81%CE%AF%CE%B1-%CF%85%CE%BB%CE%B9%CE%BA%CF%8E%CE%BD/#vegetables",
      },
      {
        namegr: "Οστρακοειδή & Μαλάκια",
        nameen: "Crustaceans & Molluscs",
        url: "https://nutrition.epantokrator.gr/%CE%B1%CE%BD%CE%B1-%CE%BA%CE%B1%CF%84%CE%B7%CE%B3%CE%BF%CF%81%CE%AF%CE%B1-%CF%85%CE%BB%CE%B9%CE%BA%CF%8E%CE%BD/#crustaceans",
      },
      {
        namegr: "Όσπρια",
        nameen: "Legumes",
        url: "https://nutrition.epantokrator.gr/%CE%B1%CE%BD%CE%B1-%CE%BA%CE%B1%CF%84%CE%B7%CE%B3%CE%BF%CF%81%CE%AF%CE%B1-%CF%85%CE%BB%CE%B9%CE%BA%CF%8E%CE%BD#legumes",
      },
      {
        namegr: "Ζυμαρικά",
        nameen: "Pasta",
        url: "https://nutrition.epantokrator.gr/%CE%B1%CE%BD%CE%B1-%CE%BA%CE%B1%CF%84%CE%B7%CE%B3%CE%BF%CF%81%CE%AF%CE%B1-%CF%85%CE%BB%CE%B9%CE%BA%CF%8E%CE%BD/#pasta",
      },
      {
        namegr: "Ρύζι",
        nameen: "Rice",
        url: "https://nutrition.epantokrator.gr/%CE%B1%CE%BD%CE%B1-%CE%BA%CE%B1%CF%84%CE%B7%CE%B3%CE%BF%CF%81%CE%AF%CE%B1-%CF%85%CE%BB%CE%B9%CE%BA%CF%8E%CE%BD/#rice",
      },
    ],
  },
  {
    tag: "cheese",
    name: "Κατάλυση αυγών και τυροκομικών (τυρινή)",
    nameen: "Eggs and Dairy are allowed",
    color: "#CD44FD",
    allow: [
      { icon: GiFruitBowl, namegr: "Φρούτα", nameen: "Fruits" },
      { icon: GiBroccoli, namegr: "Λαχανικά", nameen: "Vegetables" },
      { icon: GiOlive, namegr: "Ελιές", nameen: "Olive" },
      {
        icon: GiGrainBundle,
        namegr: "Προϊόντα που βασίζονται στα δημητριακά",
        nameen: "Cereal Products",
      },
      { icon: GiDrippingHoney, namegr: "Μέλι", nameen: "Honey" },
      { icon: GiPeas, namegr: "Όσπρια", nameen: "Legumes" },
      { icon: GiPeanut, namegr: "Ξηροί Καρποί", nameen: "Νuts" },
      {
        icon: GiSadCrab,
        namegr: "Οστρακοειδή & Μαλάκια",
        nameen: "Crustaceans & Molluscs",
      },

      { icon: TbCheese, namegr: "Γαλακτομικά", nameen: "Dairy" },
      { icon: BsEggFried, namegr: "Αυγά", nameen: "Eggs" },
      { icon: GiDoubleFish, namegr: "Ψάρια", nameen: "Fish" },
      { icon: GiJug, namegr: "Λάδι", nameen: "Olive Oil" },
      {
        icon: GiWineBottle,
        namegr: "Κρασί/ Οινοπνευματώδη ποτά",
        nameen: "Wine/ Alcohol",
      },
    ],
    notAllow: [{ icon: TbMeat, namegr: "Κρέας", nameen: "Meat" }],
    button: [
      {
        namegr: "Λαχανικά",
        nameen: "Vegetables",
        url: "https://nutrition.epantokrator.gr/%CE%B1%CE%BD%CE%B1-%CE%BA%CE%B1%CF%84%CE%B7%CE%B3%CE%BF%CF%81%CE%AF%CE%B1-%CF%85%CE%BB%CE%B9%CE%BA%CF%8E%CE%BD/#vegetables",
      },

      {
        namegr: "Ψάρια",
        nameen: "Fish",
        url: "https://nutrition.epantokrator.gr/%CE%B1%CE%BD%CE%B1-%CE%BA%CE%B1%CF%84%CE%B7%CE%B3%CE%BF%CF%81%CE%AF%CE%B1-%CF%85%CE%BB%CE%B9%CE%BA%CF%8E%CE%BD/#fish",
      },
      {
        namegr: "Οστρακοειδή & Μαλάκια",
        nameen: "Crustaceans & Molluscs",
        url: "https://nutrition.epantokrator.gr/%CE%B1%CE%BD%CE%B1-%CE%BA%CE%B1%CF%84%CE%B7%CE%B3%CE%BF%CF%81%CE%AF%CE%B1-%CF%85%CE%BB%CE%B9%CE%BA%CF%8E%CE%BD/#crustaceans",
      },
      {
        namegr: "Όσπρια",
        nameen: "Legumes",
        url: "https://nutrition.epantokrator.gr/%CE%B1%CE%BD%CE%B1-%CE%BA%CE%B1%CF%84%CE%B7%CE%B3%CE%BF%CF%81%CE%AF%CE%B1-%CF%85%CE%BB%CE%B9%CE%BA%CF%8E%CE%BD#legumes",
      },
      {
        namegr: "Ζυμαρικά",
        nameen: "Pasta",
        url: "https://nutrition.epantokrator.gr/%CE%B1%CE%BD%CE%B1-%CE%BA%CE%B1%CF%84%CE%B7%CE%B3%CE%BF%CF%81%CE%AF%CE%B1-%CF%85%CE%BB%CE%B9%CE%BA%CF%8E%CE%BD/#pasta",
      },
      {
        namegr: "Ρύζι",
        nameen: "Rice",
        url: "https://nutrition.epantokrator.gr/%CE%B1%CE%BD%CE%B1-%CE%BA%CE%B1%CF%84%CE%B7%CE%B3%CE%BF%CF%81%CE%AF%CE%B1-%CF%85%CE%BB%CE%B9%CE%BA%CF%8E%CE%BD/#rice",
      },
      {
        namegr: "Αυγά",
        nameen: "Eggs",
        url: "https://nutrition.epantokrator.gr/%CE%B1%CE%BD%CE%B1-%CE%BA%CE%B1%CF%84%CE%B7%CE%B3%CE%BF%CF%81%CE%AF%CE%B1-%CF%85%CE%BB%CE%B9%CE%BA%CF%8E%CE%BD/#eggs",
      },
    ],
  },
  {
    tag: "fish",
    name: "Κατάλυση ιχθύος",
    nameen: "Fish are allowed",
    color: "#67BFFF",
    allow: [
      { icon: GiFruitBowl, namegr: "Φρούτα", nameen: "Fruits" },
      { icon: GiBroccoli, namegr: "Λαχανικά", nameen: "Vegetables" },
      { icon: GiOlive, namegr: "Ελιές", nameen: "Olive" },
      {
        icon: GiGrainBundle,
        namegr: "Προϊόντα που βασίζονται στα δημητριακά",
        nameen: "Cereal Products",
      },
      { icon: GiDrippingHoney, namegr: "Μέλι", nameen: "Honey" },
      { icon: GiPeas, namegr: "Όσπρια", nameen: "Legumes" },
      { icon: GiPeanut, namegr: "Ξηροί Καρποί", nameen: "Νuts" },
      {
        icon: GiSadCrab,
        namegr: "Οστρακοειδή & Μαλάκια",
        nameen: "Crustaceans & Molluscs",
      },
      { icon: GiDoubleFish, namegr: "Ψάρια", nameen: "Fish" },

      { icon: GiJug, namegr: "Λάδι", nameen: "Olive Oil" },
      {
        icon: GiWineBottle,
        namegr: "Κρασί/ Οινοπνευματώδη ποτά",
        nameen: "Wine/ Alcohol",
      },
    ],
    notAllow: [
      { icon: TbCheese, namegr: "Γαλακτομικά", nameen: "Dairy" },
      { icon: BsEggFried, namegr: "Αυγά", nameen: "Eggs" },
      { icon: TbMeat, namegr: "Κρέας", nameen: "Meat" },
    ],
    button: [
      {
        namegr: "Λαχανικά",
        nameen: "Vegetables",
        url: "https://nutrition.epantokrator.gr/%CE%B1%CE%BD%CE%B1-%CE%BA%CE%B1%CF%84%CE%B7%CE%B3%CE%BF%CF%81%CE%AF%CE%B1-%CF%85%CE%BB%CE%B9%CE%BA%CF%8E%CE%BD/#vegetables",
      },

      {
        namegr: "Ψάρια",
        nameen: "Fish",
        url: "https://nutrition.epantokrator.gr/%CE%B1%CE%BD%CE%B1-%CE%BA%CE%B1%CF%84%CE%B7%CE%B3%CE%BF%CF%81%CE%AF%CE%B1-%CF%85%CE%BB%CE%B9%CE%BA%CF%8E%CE%BD/#fish",
      },
      {
        namegr: "Οστρακοειδή & Μαλάκια",
        nameen: "Crustaceans & Molluscs",
        url: "https://nutrition.epantokrator.gr/%CE%B1%CE%BD%CE%B1-%CE%BA%CE%B1%CF%84%CE%B7%CE%B3%CE%BF%CF%81%CE%AF%CE%B1-%CF%85%CE%BB%CE%B9%CE%BA%CF%8E%CE%BD/#crustaceans",
      },
      {
        namegr: "Όσπρια",
        nameen: "Legumes",
        url: "https://nutrition.epantokrator.gr/%CE%B1%CE%BD%CE%B1-%CE%BA%CE%B1%CF%84%CE%B7%CE%B3%CE%BF%CF%81%CE%AF%CE%B1-%CF%85%CE%BB%CE%B9%CE%BA%CF%8E%CE%BD#legumes",
      },
      {
        namegr: "Ζυμαρικά",
        nameen: "Pasta",
        url: "https://nutrition.epantokrator.gr/%CE%B1%CE%BD%CE%B1-%CE%BA%CE%B1%CF%84%CE%B7%CE%B3%CE%BF%CF%81%CE%AF%CE%B1-%CF%85%CE%BB%CE%B9%CE%BA%CF%8E%CE%BD/#pasta",
      },
      {
        namegr: "Ρύζι",
        nameen: "Rice",
        url: "https://nutrition.epantokrator.gr/%CE%B1%CE%BD%CE%B1-%CE%BA%CE%B1%CF%84%CE%B7%CE%B3%CE%BF%CF%81%CE%AF%CE%B1-%CF%85%CE%BB%CE%B9%CE%BA%CF%8E%CE%BD/#rice",
      },
    ],
  },
];
const Tags = ({ tag }) => {
  const formattedTag = tag.toString();
  console.log(formattedTag);

  const finalTag = tagChoices.filter((item) => item.tag === formattedTag);
  console.log(finalTag);

  return finalTag.map((item) => (
    <div>
      <div key={item.tag}>
        <span
          style={{
            // background: "#FEECE6",
            "border-radius": "4px",
            "text-align": "center",
            padding: "8px 12px",
            gap: "4px",
            "font-style": "normal",
            "font-weight": "400",
            "font-size": "18px",
            "line-height": "21px",
            fontFamily: "Helvetica Neue",
          }}
        >
          <BsCircleFill
            style={{ marginRight: "5px" }}
            color={`${item.color}`}
            fontSize={"0.8em"}
          />

          <TranslatedText
            greekText={`<span lang='el'> ${item.name}</span>`}
            englishText={`<span lang='en'> ${item.nameen}</span>`}
          />
        </span>
      </div>
      <div>
        <p
          style={{
            "border-bottom": "1px solid #F13D3D",
            "margin-top": "20px",
            "font-style": "normal",
            "font-weight": "500",
            "font-size": "14px",
            "line-height": "17px",
            fontFamily: "Helvetica Neue",
            marginBottom: "13.5px",
          }}
        >
          <TranslatedText
            greekText={`<span lang='el'> ΑΠΕΧΟΥΜΕ</span>`}
            englishText={`<span lang='en'> NOT ALLOWED</span>`}
          />
        </p>
        <div style={{ display: "inline-block" }}>
          {item.notAllow &&
            item?.notAllow.map((item) => (
              <span
                style={{
                  marginRight: "10px",
                  display: "inline-flex",
                  "font-style": "normal",
                  "font-weight": "400",
                  "font-size": "18px",
                  "line-height": "21px",
                  fontFamily: "Helvetica Neue",
                }}
              >
                <item.icon style={{ marginRight: "5px" }} />

                <TranslatedText
                  greekText={`<span lang='el'> ${item.namegr}</span>`}
                  englishText={`<span lang='en'> ${item.nameen}</span>`}
                />
              </span>
            ))}
        </div>
        <p
          style={{
            "border-bottom": "1px solid #15A22B",
            "font-style": "normal",
            "font-weight": "500",
            "font-size": "14px",
            "line-height": "17px",
            fontFamily: "Helvetica Neue",
            marginBottom: "13.5px",
            marginTop: "40px",
          }}
        >
          <TranslatedText
            greekText={`<span lang='el'>ΕΠΙΤΡΕΠΟΝΤΑΙ</span>`}
            englishText={`<span lang='en'>ALLOWED</span>`}
          />
        </p>
        <div style={{ display: "inline-block" }}>
          {item.allow &&
            item?.allow.map((item) => (
              <span
                style={{
                  marginRight: "10px",
                  display: "inline-flex",
                  "font-style": "normal",
                  "font-weight": "400",
                  "font-size": "18px",
                  "line-height": "21px",
                  fontFamily: "Helvetica Neue",
                }}
              >
                <item.icon style={{ marginRight: "5px" }} />
                <TranslatedText
                  greekText={`<span lang='el'> ${item.namegr}</span>`}
                  englishText={`<span lang='en'> ${item.nameen}</span>`}
                />
              </span>
            ))}
        </div>
        <div
          style={{
            padding: "12px 0px",
            gap: "8px",
            "border-radius": "4px",
            marginTop: "40px",
          }}
        >
          <p
            style={{
              "border-bottom": "1px solid #E6E6E6",
              "font-style": "normal",
              "font-weight": "500",
              "font-size": "14px",
              "line-height": "17px",
              fontFamily: "Helvetica Neue",
              marginBottom: "13.5px",
            }}
          >
            <TranslatedText
              greekText={`<span lang='el'><b>ΠΡΟΤΕΙΝΟΜΕΝΟ ΓΕΥΜΑ</b></span>`}
              englishText={`<span lang='en'><b>RECOMMENDED MEAL</b></span>`}
            />
          </p>
          <span
            style={{
              "font-style": "normal",
              "font-weight": "400",
              "font-size": "18px",
              "line-height": "150%",
              paddingLeft: "5px",
              fontFamily: "Helvetica Neue",
            }}
          >
            <b>
              {" "}
              <TranslatedText
                greekText={`<span lang='el'>Σαλάτα</span>`}
                englishText={`<span lang='en'>Salad</span>`}
              />
            </b>
            :{" "}
            <TranslatedText
              greekText={`<span lang='el'>Σαλάτα εποχής</span>`}
              englishText={`<span lang='en'>Salad with tomatoes and cucumber</span>`}
            />
            <br></br>{" "}
            <b style={{ paddingLeft: "5px" }}>
              {" "}
              <TranslatedText
                greekText={`<span lang='el'>Φρούτο</span>`}
                englishText={`<span lang='en'>Fruits</span>`}
              />
            </b>
            :
            <TranslatedText
              greekText={`<span lang='el'> Φρούτο εποχής</span>`}
              englishText={`<span lang='en'>Apple or Banana</span>`}
            />
          </span>
          <br></br>

          <span
            style={{
              "font-style": "normal",
              "font-weight": "400",
              "font-size": "18px",
              "line-height": "150%",
              fontFamily: "Helvetica Neue",
              marginBottom: "13.5px",
              marginTop: "8px",
              paddingLeft: "5px",
            }}
          >
            <TranslatedText
              greekText={`<span lang='el'><b>Επιλογές Κυρίως Πιάτου:</b></span>`}
              englishText={`<span lang='en'><b>
            Main Dish Options:</b></span>`}
            />
          </span>
          <br></br>
          <div style={{ display: "inline-block" }}>
            {item.button &&
              item?.button.map((item) => (
                <Tag
                  className="tagForCategories"
                  style={{
                    padding: "8px 12px",
                    gap: "8px",
                    "border-radius": "4px",
                  }}
                  color="#2B0668"
                >
                  <a href={item.url}>
                    <TranslatedText
                      greekText={`<span lang='el'> ${item.namegr}</span>`}
                      englishText={`<span lang='en'> ${item.nameen}</span>`}
                    />
                  </a>
                </Tag>
              ))}
          </div>
        </div>
      </div>
    </div>
  ));
};

export default Tags;
